'use client'

// The piano, standing in the world.
//
// Sam's model, placed in Blender. The node carries its own world
// transform (translation ~[20.2, 1.17, -51.9], scale 5), so this renders
// at IDENTITY like the ruins do: my first cut wrapped it in a group at
// the POI as well, which added the two together and put the piano at
// roughly [42, 1.2, -102], outside the town and invisible from anywhere
// a person stands. Baked transform plus a positioned parent is the same
// footgun the director rig hit with dragged props.
//
// The sim's POI (playPiano, [21.834, 0, -50.741]) is where the BIRD
// walks to, about a metre and a half from the stool, which is right: he
// stands at the piano rather than inside it. Moving the instrument means
// moving it in Blender and re-exporting; moving where he sits means the
// POI. Materials go through the useNodeMaterials idiom (fresh
// MeshStandardNodeMaterial, explicit fields, never copy()) so it lights,
// shadows and dithers with the rest of the town.

import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/piano.glb'

export function Piano() {
  const { scene } = useModel(MODEL)

  // The audit found this file's inline copy skipped material ARRAYS,
  // the exact bug the other three copies' comments warn about. The shared
  // hook has the branch.
  useSceneNodeMaterials(scene, { roughness: 0.9 })

  // Baked transform: render at identity.
  return <primitive object={scene} />
}
